import React, { Component } from "react";
import styled from "styled-components";
import { XLarge, Gear } from "@vitalsource/vstui-icons";
import ToolbarButton from "./toolbar-button";
import ReCenterButton from "./re-center-button";
import TtsSettingsDialog from "./tts-settings-dialog";
import { BAR_HEIGHT, getBarColor } from "./vars";
import CenterControls from "./center-controls";
import { Dispatcher } from "../../gadgets/flux";

const Styled = {
  OuterContainer: styled.div`
    width: 100%;
    height: ${BAR_HEIGHT}px;
    background-color: ${getBarColor};
    position: relative;
  `,
  LeftContainer: styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    z-index: 1;
  `,
  CenterContainer: styled.div`
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  `,
  RightContainer: styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 11px;
    & > * {
      vertical-align: top;
    }
  `
};

export default class ToolBar extends Component {
  state = {
    showingSettingsDialog: false
  };

  componentDidMount() {
    window.setTimeout(() => {
      const buttons = this.container.querySelectorAll("button:not(:disabled)");
      buttons[0].focus();
    }, 0);
    Dispatcher.emit(Dispatcher.TTS_OPEN);
  }

  showSettings = () => {
    this.setState({
      showingSettingsDialog: true
    });
  };

  closeSettings = () => {
    this.setState({
      showingSettingsDialog: false
    });
  };

  render() {
    return (
      <Styled.OuterContainer
        role="region"
        aria-label={i18n.t("tts.toolbar-alt")}
        innerRef={el => (this.container = el)}
      >
        <Styled.LeftContainer>
          {this.props.enableRecenter && (
            <ReCenterButton onClick={this.props.onRecenter} />
          )}
        </Styled.LeftContainer>
        <Styled.CenterContainer>
          <CenterControls
            isPlaying={this.props.isPlaying}
            onSkipBack={this.props.onSkipBack}
            onSkipForward={this.props.onSkipForward}
            onPause={this.props.onPause}
            onPlay={this.props.onPlay}
            isReady={this.props.isReady}
            canNav={this.props.canNav}
          />
        </Styled.CenterContainer>
        <Styled.RightContainer>
          <ToolbarButton
            label={i18n.t("tts.settings")}
            icon={<Gear />}
            onClick={this.showSettings}
          />
          <ToolbarButton
            label={i18n.t("base.close")}
            icon={<XLarge />}
            onClick={this.props.onClose}
          />
        </Styled.RightContainer>
        <TtsSettingsDialog
          isOpen={this.state.showingSettingsDialog}
          onRequestClose={this.closeSettings}
          changeRate={this.props.changeRate}
          setVoice={this.props.setVoice}
          close={this.props.close}
          enableAltText={this.props.enableAltText}
          disableAltText={this.props.disableAltText}
          voices={this.props.voices}
          currentRate={this.props.currentRate}
          currentVoice={this.props.currentVoice}
          altEnabled={this.props.altEnabled}
        />
      </Styled.OuterContainer>
    );
  }
}

ToolBar.defaultProps = {
  isReady: true
};
